import styled from "styled-components";
import { WidgetSettingFC } from "types/Setting";

interface MicPermissionProps {}

export const MicPermissionSetting: WidgetSettingFC<PermissionState, MicPermissionProps> = ({
  data,
  setData,
}) => {
  return (
    <>
      {(data === "denied" || data === "prompt") && (
        <Body>
          We have detected that you are yet to provide permission to use the microphone in the
          browser. In order to use this widget, you will need to allow this page to access your
          microphone.
        </Body>
      )}
    </>
  );
};

const Body = styled.p`
  margin-bottom: 15px;
  color: var(--danger);
`;
